import { FC, useState } from 'react';
import { Link } from 'react-router-dom';
import { Setting } from '../App';
import { useAddress } from '../hooks/use-address';
import base from '../styles/Base.module.css';

export const Address: FC<{ setting: Setting }> = ({ setting }) => {
  const [isLargeWindowSize, setIsLargeWindowSize] = useState<boolean>();
  const { subscription, formRef, redirectToShowPage, setSubscription, changeCountry, submit } = useAddress(setting);

  if (!subscription) {
    return <></>;
  }

  if (!subscription.shop.showChangeAddress) {
    redirectToShowPage();

    return <></>;
  }

  const countryOptions = subscription.countries.map((country, i) => (
    <option key={i} value={country.code} selected={country.code === subscription.deliveryCountryCode}>
      {country.name}
    </option>
  ));

  const provinceOptions = subscription.country.zones.map((zone, i) => (
    <option key={i} value={zone.code} selected={zone.code === subscription.deliveryProvinceCode}>
      {zone.name}
    </option>
  ));

  // checkValidations
  const checkValidations = (element: any) => {
    // required属性があれば
    if (element.required) {
      if (element.value === '') {
        element.classList.add('invalid');
        // inputの後ろにエラーメッセージを追加
        const errorMessage = document.createElement('span');
        errorMessage.className = base.errorMessage;
        errorMessage.textContent = '入力は必須です';
        if (element.dataset.errortext) {
          errorMessage.textContent = element.dataset.errortext;
        }
        errorMessage.style.color = '#dc2f2f';
        errorMessage.style.fontSize = '12px';
        if (!element.nextSibling) {
          element.parentNode.insertBefore(errorMessage, element.nextSibling);
        }
      } else {
        element.classList.remove('invalid');
        // エラーメッセージがあれば削除
        if (element.nextSibling) {
          element.parentNode.removeChild(element.nextSibling);
        }
      }
    }

    // パターン属性があれば
    if (element.pattern) {
      // パターンに一致していない場合はエラー
      if (!element.value.match(element.pattern)) {
        element.classList.add('invalid');

        // inputの後ろにエラーメッセージを追加
        const errorMessage = document.createElement('span');
        errorMessage.className = base.errorMessage;
        errorMessage.textContent = '入力形式が正しくありません';
        console.log(element.dataset.errortext);
        if (element.dataset.errortext) {
          errorMessage.textContent = element.dataset.errortext;
        }
        errorMessage.style.color = '#dc2f2f';
        errorMessage.style.fontSize = '12px';
        console.log(element.nextSibling);
        if (!element.nextSibling) {
          element.parentNode.insertBefore(errorMessage, element.nextSibling);
        }
      } else {
        element.classList.remove('invalid');
        // エラーメッセージがあれば削除
        if (element.nextSibling) {
          element.parentNode.removeChild(element.nextSibling);
        }
      }
    }

    console.log('checkValidations', element.value);
  };

  const confirm = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    // ページ内のすべての要素を取得し、それぞれの要素に対してバリデーションを行う
    const allElements = document.querySelectorAll('input, textarea, select');
    let hasError = false;

    allElements.forEach((element) => {
      checkValidations(element);
      // エラーがあるかどうかをチェック
      if (element.classList.contains('invalid')) {
        hasError = true;
      }
    });

    // エラーがない場合に送信
    if (!hasError) {
      submit(event);
    }
  };

  window.addEventListener('message', (e) => {
    if (e.data.windownnerWidth) {
      setIsLargeWindowSize(e.data.windownnerWidth > 999);
    }
  });
  window.parent.postMessage({ action: 'renderSubcription' }, '*');

  return (
    <div className={base.addressContainer}>
      <form ref={formRef}>
        <div className="form-vertical">
          {/* <h2 className={base.sectionHeading}>配送住所を編集する</h2> */}
          <h1 className={`${base.pageHeading} ${base.pageLargeHeading}` && isLargeWindowSize ? base.addressPc : base.addressSp}>
            Shipping address
            <span className={isLargeWindowSize ? base.large : base.subOrder}>配送先情報の編集</span>
          </h1>

          <div className={base.inputFieldGroup}>
            <div className={base.inputField}>
              <label className={base.inputLabel}>
                お名前<span className={base.inputRequired}>必須</span>
              </label>
              <input
                type="text"
                required
                onChange={(event) => {
                  checkValidations(event.target);
                  setSubscription({
                    ...subscription,
                    deliveryLastName: event.target.value,
                  });
                }}
                value={subscription.deliveryLastName}
                className={base.inputFieldText}
                placeholder="姓"
              />
            </div>

            <div className={base.inputField}>
              <label className={base.inputLabel}>
                <span className={base.inputRequired}>必須</span>
              </label>
              <input
                type="text"
                required
                onChange={(event) => {
                  checkValidations(event.target);
                  setSubscription({
                    ...subscription,
                    deliveryFirstName: event.target.value,
                  });
                }}
                value={subscription.deliveryFirstName}
                className={base.inputFieldText}
                placeholder="名"
              />
            </div>
          </div>

          <div className={base.inputFieldGroup}>
            {/* <div className={base.inputField}>
              <label className={base.inputLabel}>国/地域</label>
              <select
                onChange={(event) => {
                  changeCountry(event.target.value);
                }}
                className={base.inputFieldSelect}
              >
                {countryOptions}
              </select>
            </div> */}

            <div className={base.inputField}>
              <label className={base.inputLabel}>
                郵便番号<span className={base.inputRequired}>必須</span>
              </label>
              <input
                type="text"
                required
                onChange={(event) => {
                  checkValidations(event.target);
                  setSubscription({
                    ...subscription,
                    deliveryZip: event.target.value,
                  });
                }}
                value={subscription.deliveryZip}
                className={base.inputFieldText}
                placeholder="000-0000(ハイフンあり数字7ケタ)"
                pattern="[0-9]{3}-[0-9]{4}"
                data-errortext="ハイフンありの数字7桁でご記入ください"
              />
            </div>
          </div>

          <div className={`${base.inputFieldGroup} ${base.inputFieldGroupWide}`}>
            <div className={base.inputField}>
              <label className={base.inputLabel}>
                都道府県<span className={base.inputRequired}>必須</span>
              </label>
              <select
                onChange={(event) => {
                  checkValidations(event.target);
                  setSubscription({
                    ...subscription,
                    deliveryProvinceCode: event.target.value,
                  });
                }}
                className={base.inputFieldSelect}
              >
                {provinceOptions}
              </select>
            </div>

            <div className={base.inputField}>
              <label className={base.inputLabel}>
                市区町村<span className={base.inputRequired}>必須</span>
              </label>
              <input
                type="text"
                required
                onChange={(event) => {
                  checkValidations(event.target);
                  setSubscription({
                    ...subscription,
                    deliveryCity: event.target.value,
                  });
                }}
                value={subscription.deliveryCity}
                className={base.inputFieldText}
                placeholder="〇〇市〇◯区〇〇町"
              />
            </div>
          </div>

          <div className={`${base.inputFieldGroup} ${base.inputFieldGroupWide}`}>
            <div className={base.inputField}>
              <label className={base.inputLabel}>
                住所<span className={base.inputRequired}>必須</span>
              </label>
              <input
                type="text"
                required
                onChange={(event) => {
                  checkValidations(event.target);
                  setSubscription({
                    ...subscription,
                    deliveryAddress1: event.target.value,
                  });
                }}
                value={subscription.deliveryAddress1}
                className={base.inputFieldText}
                placeholder="〇番〇号"
              />
            </div>

            <div className={base.inputField}>
              <label className={base.inputLabel}>建物名、部屋番号 (任意)</label>
              <input
                type="text"
                onChange={(event) =>
                  setSubscription({
                    ...subscription,
                    deliveryAddress2: event.target.value,
                  })
                }
                value={subscription.deliveryAddress2}
                className={base.inputFieldText}
                placeholder="〇〇マンション101号"
              />
            </div>
          </div>

          <div className={`${base.inputFieldGroup} ${base.inputFieldGroupWide}`}>
            <div className={base.inputField}>
              <label className={base.inputLabel}>
                電話番号<span className={base.inputRequired}>必須</span>
              </label>
              <input
                type="text"
                onChange={(event) => {
                  checkValidations(event.target);
                  setSubscription({
                    ...subscription,
                    deliveryPhone: event.target.value,
                  });
                }}
                value={subscription.deliveryPhone}
                className={base.inputFieldText}
                placeholder="ハイフン不要"
                pattern="[0-9]{9,11}"
                data-errortext="9桁以上12桁未満の数字でご記入ください"
              />
            </div>
          </div>

          <div className={`${base.inputFieldSubmitGroup} ${base.updateAddress}`}>
            <button
              onClick={confirm}
              type="submit"
              disabled={subscription.disabled}
              className={`${base.sectionBtn} ${base.updateAddress} ${base.ml20}`}
            >
              登録情報を更新する
              <span className={base.ModalButtonArrow}>
                <img src="/image/icon_arrow.svg" alt="" />
              </span>
            </button>
            <Link to={`/`} className={`${base.sectionReverseBtn} ${base.cancelUpdateAddress}`}>
              キャンセルする
            </Link>
          </div>
        </div>
      </form>
    </div>
  );
};
